import * as Animate from "react-reveal";
import GraduationImg from "../../../assets/images/png/global-mba-graduation-group-v1.webp";
import ChideraImg from "../../../assets/images/png/bankole-adesina-v1.png";
import BankoleImg from "../../../assets/images/png/chidera-robert-v1.png";

const stats = [
  { label: "Total sales", value: "$248K" },
  { label: "Growth", value: "+18%" },
  { label: "Regions", value: "06" },
];

const bars = [44, 69, 52, 86, 73, 94];

const testimonials = [
  {
    quote:
      "I completed my first Data Analytics internship project, analysing payroll data with Excel for cleaning and visualisation.",
    name: "Chidera Robert",
    role: "Data Analytics learner",
    image: ChideraImg,
  },
  {
    quote:
      "My three-month journey helped me refine my mindset and design process. Even as a practising designer, I gained deeper insight into the why behind design.",
    name: "Bankolé Adesina",
    role: "UX Designer",
    image: BankoleImg,
  },
];

const HomeEvidenceSection = () => {
  return (
    <section className="bg-[#f7f9fe] py-16 md:py-24 px-4" id="stories">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div className="grid home-grid-1115 items-end gap-6 lg:gap-20 mb-10 md:mb-12">
            <div>
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
                <span className="w-8 h-[3px] bg-secondary inline-block"></span>
                Learner evidence
              </p>
              <h2 className="text-primary font-poppins font-bold tracking-[-0.045em] leading-[1.12] text-3xl md:text-4xl lg:text-6xl">
                See what Utiva learners are building.
              </h2>
            </div>
            <p className="text-gray text-base font-poppins leading-[1.8]">
              Project work, portfolio evidence and honest learner stories show
              what practical progress can look like.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid home-grid-1208 gap-4">
          <Animate.Fade bottom>
            <article className="bg-primary min-h-[400px] md:min-h-[520px] text-white rounded-3xl grid home-grid-testimonial-card items-center gap-6 md:gap-7 p-6 md:p-7">
              <div
                className="bg-white text-default rounded-[18px] min-h-[300px] md:min-h-[360px] p-5 md:p-6 shadow-course-feature-lg"
                style={{ transform: "rotate(-1.5deg)" }}
                aria-label="Illustrative learner dashboard project"
              >
                <div className="flex items-center justify-between text-sm font-extrabold">
                  <span className="text-primary font-poppins">
                    DATA PROJECT
                  </span>
                  <b className="text-[#a16800] font-poppins">POWER BI</b>
                </div>
                <div className="grid grid-cols-3 gap-2 my-6">
                  {stats.map((stat) => (
                    <span
                      key={stat.label}
                      className="bg-hire-tint-blue rounded-[10px] grid gap-1 p-3"
                    >
                      <small className="text-gray-2 font-poppins text-sm">
                        {stat.label}
                      </small>
                      <strong className="text-primary font-poppins text-lg">
                        {stat.value}
                      </strong>
                    </span>
                  ))}
                </div>
                <div className="flex items-end gap-2 border-l border-b border-hire-line h-[190px] pt-4 px-4">
                  {bars.map((height, index) => (
                    <i
                      key={index}
                      className="flex-1 rounded-t-md block"
                      style={{
                        height: `${height}%`,
                        background:
                          "linear-gradient(var(--color-secondary), #ffd979)",
                      }}
                    />
                  ))}
                </div>
              </div>

              <div>
                <span className="text-secondary tracking-[0.09em] font-poppins text-sm font-extrabold">
                  PROJECT EXAMPLE
                </span>
                <h3 className="my-3 text-xl md:text-[27px] font-bold font-poppins leading-[1.3]">
                  From raw business data to a decision-ready dashboard.
                </h3>
                <p className="text-[#d7dfff] text-sm font-poppins leading-[1.75] m-0">
                  Learners practise cleaning data, building measures and
                  presenting an evidence-based recommendation.
                </p>
              </div>
            </article>
          </Animate.Fade>

          <div className="grid gap-4">
            {testimonials.map((testimonial) => (
              <Animate.Fade bottom key={testimonial.name}>
                <blockquote className="border border-hire-line bg-white rounded-[22px] flex flex-col p-7 m-0">
                  <p className="text-primary text-lg font-poppins font-semibold leading-[1.7] mb-7">
                    &ldquo;{testimonial.quote}&rdquo;
                  </p>
                  <footer className="mt-auto flex items-center gap-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-14 h-14 rounded-full object-cover border-2 border-hire-line"
                    />

                    <div className="grid gap-0.5">
                      <strong className="text-lg font-semibold font-poppins not-italic text-default">
                        {testimonial.name}
                      </strong>

                      <span className="text-gray font-poppins text-base">
                        {testimonial.role}
                      </span>
                    </div>
                  </footer>
                </blockquote>
              </Animate.Fade>
            ))}
          </div>
        </div>

        <Animate.Fade bottom>
          <figure className="relative rounded-3xl min-h-[420px] items-start mt-4 overflow-hidden m-0">
            <img
              src={GraduationImg}
              alt="Illustrative Utiva Global MBA graduates wearing graduation sashes"
              className="w-full object-cover items-start"
              style={{ height: "420px", objectPosition: "center 25%" }}
            />
            <div
              className="absolute inset-x-0 bottom-0 top-[35%]"
              style={{
                background: "linear-gradient(transparent, rgba(3,4,107,0.93))",
              }}
            />
            <figcaption className="absolute z-[1] text-white grid gap-1.5 bottom-7 left-6 right-6 md:left-8 md:right-8">
              <span className="text-secondary tracking-[0.09em] font-poppins text-sm font-extrabold">
                GRADUATION OUTCOME
              </span>
              <strong className="text-xl font-poppins md:text-2xl">
                A milestone that makes completed work visible.
              </strong>
            </figcaption>
          </figure>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HomeEvidenceSection;
